<template>
  <router-view></router-view>
</template>
<script>
  export default {
    name: "nullPage"
  }
</script>
<style scoped>
</style>